// custom (2026-08-09, Lote 2): módulo Vuex do CONTADOR de notificações não lidas.
//
// Namespace: 'cwCustomCrmNotificacoes'. Só existe por causa do BADGE da sidebar: o
// `SidebarGroupHeader` lê o número por `useMapGetter(getterKeys.count)`, ou seja, exige um
// getter do Vuex. Um ref de composable não serve ali — e criar um caminho paralelo de badge
// só para fugir do store seria um segundo mecanismo fazendo o trabalho de um.
//
// ⚠️ O QUE ESTE MÓDULO **NÃO** É: ele não guarda a lista. A tela de Notificações busca a
// própria lista e é dona dela. Duplicar a lista aqui criaria duas verdades sobre o mesmo
// dado — a da tela (recém-carregada) e a do store (do último polling) —, e o dia em que as
// duas discordassem o operador veria "3" no menu e duas linhas na tela.
//
// A CONTAGEM VEM DO SERVIDOR, sempre. Ela soma DUAS tabelas (a nossa e a `notifications` do
// core) e só o `NotificationReader` sabe fazer essa soma. Contar no cliente daria um número
// que discorda da lista assim que uma das fontes mudar.
import CrmNotificationsAPI from 'dashboard/api/cw_custom/crmNotifications';

const state = {
  unreadCount: 0,
};

export const getters = {
  getUnreadCount: $state => $state.unreadCount,
};

export const mutations = {
  SET_UNREAD_COUNT($state, count) {
    $state.unreadCount = Number(count) || 0;
  },
};

export const actions = {
  // Busca a contagem. Degrada em silêncio: com a flag desligada o endpoint responde 404, e
  // isso não é erro — é a conta não ter a feature. Badge zerado é a leitura certa.
  async fetchUnreadCount({ commit }, accountId) {
    try {
      const { data } = await CrmNotificationsAPI.fetchNotifications(accountId);
      commit('SET_UNREAD_COUNT', data.unread_count ?? 0);
    } catch {
      commit('SET_UNREAD_COUNT', 0);
    }
  },

  // Chamado pela própria tela depois de marcar como lida, para o menu não ficar mostrando um
  // número que a pessoa acabou de zerar na tela ao lado.
  setUnreadCount({ commit }, count) {
    commit('SET_UNREAD_COUNT', count);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
